import { ValidationFunctionResult } from '../../types/validation-function-result';
import { legalAgeSchema } from '../schemas/legal-age.schema';

/**
 * Validates if a date is of legal age.
 * @param date - The date to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const isLegalAge = (
	date: Date,
	legalAge: number,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Validate
	const { error } = legalAgeSchema(legalAge).validate(date, {
		abortEarly,
	});

	// Check
	if (error) {
		return {
			isValid: false,
			errors: error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
